export const socialSelector = {
  socialSelectorViewStories: "Bekyk stories",
  socialSelectorGoToProfile: "Gaan na profiel",
  socialSelectorGoToCommunity: "Gaan na gemeenskap",
  socialSelectorCancel: "Kanselleer",
  socialSelectorOptionsFor: "Opsies vir {{name}}",
  socialSelectorLabelAyg: "Amptelike platform",
  socialSelectorLabelProvider: "Speletjiesverskaffer",
  socialSelectorLabelUser: "Speler",
  socialSelectorLabelCommunity: "Randrush-gemeenskap",
  socialSelectorPlayInFeed: "Speel in die stroom",
};
